<template>
  <div class="k-form-field form-group" :class="fieldClasses">
    <label v-if="label" :for="fieldId">
      {{ label }}<k-tooltip
        v-if="tooltip"
        :text="tooltip"
        :trigger-label="label ? `More information about ${label}` : 'More information'"
      ><i class="fas fa-info-circle" aria-hidden="true"></i></k-tooltip>
    </label>
    <slot></slot>
    <small v-if="hasError" class="field-error">
      <i class="fas fa-exclamation-circle" aria-hidden="true"></i> This field is required
    </small>
  </div>
</template>

<style scoped>
.k-form-field .fa-info-circle {
  margin-left: 4px;
}

.field-error {
  color: var(--kate-type-danger);
  font-size: 0.9rem;
}

.k-form-field.has-error {
  border: 1px solid var(--kate-type-danger) !important;
  border-radius: 8px;
  padding: 8px;
}

.k-form-field.has-warning {
  border: 1px solid var(--kate-type-warning) !important;
  border-radius: 8px;
  padding: 8px;
}
</style>

<script>
import { KTooltip } from '@kate/components';

export default {
  name: 'KFormField',

  components: {
    KTooltip,
  },

  props: {
    label: {
      type: String,
      default: '',
    },
    fieldId: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
      default: '',
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    hasWarning: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    fieldClasses() {
      return {
        'form-required': this.required,
        'has-error': this.hasError,
        'has-warning': this.hasWarning,
      };
    },
  },
};
</script>
